// Node Modules
import { RichText } from 'prismic-reactjs';

// Components
import Button from '@/components/global-components/Button';

// Themes
import theme from '@/themes/index';

const InformationItem = ({
  content: {
    item: {
      title,
      logoImage,
      primaryButton, 
    },
  },
}) => {
  return (
    <>
      <div className='item-container'>
        <h6 dangerouslySetInnerHTML={{
          __html: title, 
        }}></h6>
        <div className='button-logo-container'>
          <img src={logoImage.url}></img>
          <Button
            text={primaryButton.title}
            className={primaryButton.style.toLowerCase()}
            href={primaryButton.url}
            target={primaryButton.openInAnotherPage ? '_blank' : '_self'}
            styles={{
              width: 'fit-content',
              padding: '0 1rem',
            }}></Button>
        </div>
      </div>
      <style jsx>{`
        div.item-container {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        div.item-container h6 {
          line-height: 1.5rem !important;
          font-family: ${theme.fontFamilies.montserratBold};
          padding-bottom: 1.75rem;
          margin-block-start: 0;
          margin-block-end: 0;
          margin-inline-start: 0;
          margin-inline-end: 0;
          min-height: 4rem;
        }

        div.item-container .button-logo-container {
          display: flex;
          flex-direction: column;
          width: 100%;
          align-items: center;
        }

        div.item-container .button-logo-container img {
          width: fit-content;
          padding-bottom: 2.5625rem;
          min-height: 19rem;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.item-container h6 {
            font-size: 1rem;
            line-height: 2.25rem;
          }

          div.item-container .button-logo-container {
            align-items: flex-start;
          }

          div.item-container .button-logo-container img {
            max-height: 19.8125rem;
          }
        }
      `}</style>
    </>
  );
};

export default InformationItem;
